module.exports = __webpack_public_path__ + "img/luojijiagoutu.2e3b37a0.png";